module.exports = __webpack_public_path__ + "static/img/right.a3ef1dbf.svg";